import React from 'react';
import { Flex, Text, Tooltip } from '@tapresearch/ui/components';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
export function CustomTick(tick) {
    return /*#__PURE__*/ React.createElement("g", {
        transform: "translate(".concat(tick.x - 120, ",").concat(tick.y - 24, ")")
    }, /*#__PURE__*/ React.createElement("foreignObject", {
        overflow: "visible",
        width: "110",
        height: "45"
    }, /*#__PURE__*/ React.createElement(OpacityTransitionBox, null, /*#__PURE__*/ React.createElement(Flex, {
        h: "full",
        alignItems: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Text, {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        align: "center",
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        label: tick.value,
        padding: "2",
        borderRadius: "md"
    }, tick.value))))));
}
